import type { AppRoute } from '../types';
import commonRoutes from './common';
import documentsRoutes from './documents';
import notFoundRoute from './notFound';
import profileRoutes from './profile';
import powAttorneyRoutes from './powersAttorney';
import agreementsRoutes from './agreements';
import errorsRoutes from './error';

const appRoutes: AppRoute[] = [
  ...commonRoutes,
  ...profileRoutes,
  ...documentsRoutes,
  ...powAttorneyRoutes,
  ...agreementsRoutes,
  ...errorsRoutes,
  notFoundRoute,
];

export default appRoutes;
